/** Time left until a phase deadline, corrected for client/server clock skew.

`syncedAt` is the client time when `serverNow` was received. Later ticks must
keep that same pair. Re-pairing an old serverNow with a new Date.now() puts
the full phase time back on screen.
*/
export function phaseRemainingMs(
  deadlineMs: number,
  serverNowMs: number,
  syncedAtMs: number,
  nowMs: number,
): number {
  const offset = serverNowMs - syncedAtMs;
  return Math.max(0, deadlineMs - (nowMs + offset));
}

/** Time since the phase opened, using the same server/client pair as the countdown. */
export function phaseElapsedMs(
  phaseEnteredAtMs: number | null,
  serverNowMs: number,
  syncedAtMs: number,
  nowMs: number,
): number | null {
  if (phaseEnteredAtMs == null || Number.isNaN(phaseEnteredAtMs)) return null;
  const offset = serverNowMs - syncedAtMs;
  return Math.max(0, Math.round(nowMs + offset - phaseEnteredAtMs));
}
